import { render, staticRenderFns } from "./textEllipsis.vue?vue&type=template&id=033b1e49&"
import script from "./textEllipsis.vue?vue&type=script&lang=js&"
export * from "./textEllipsis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.10.0_m252fu66fivcrdajfhoxhvxrne/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports